import React from "react";
import { BrandMark } from "@/components/brand/BrandLogo";
import { GUIDES } from "@/lib/guides";

const K = { fontFamily: "Kanit, Arial, sans-serif" };
const S = { fontFamily: "'Noto Serif', Georgia, serif" };

// Editorial "booklet" rendering of the selected free guide. Chapters mirror the real section headings of each PDF.
const VISUAL = {
  digital_nomad: { img: "/img/home-help.jpg", chapters: ["Living and Working in Spain", "Two Routes, One Destination", "Key Financial Requirements", "The Route to the Visa"] },
  non_lucrative: { img: "/img/home-final.jpg", chapters: ["Spain as a Life Decision", "Financial Means & Key Requirements", "The Path to the Visa", "Living in Spain: First 90 Days"] },
  buying_property: { img: "/img/spain-cover.jpg", chapters: ["Ownership Is Not Residency", "Your First Step: the NIE", "Due Diligence & the Purchase Process", "Financing and Taxes as a U.S. Buyer"] },
};

export default function GuideVisual({ guide }) {
  const v = guide ? VISUAL[guide.id] : null;
  const title = guide ? guide.title : "Three free guides";
  const items = v ? v.chapters : GUIDES.map((g) => g.title);

  return (
    <div data-testid="guide-visual" data-guide={guide?.id || "none"} className="relative w-[280px] sm:w-[320px] md:w-[360px] aspect-[3/4] mx-auto lg:mx-0">
      <div aria-hidden="true" className="absolute inset-0 translate-x-3 translate-y-3 bg-[#F5EFE7] border border-[#451C25]/10 shadow-md" />
      <div aria-hidden="true" className="absolute inset-0 translate-x-1.5 translate-y-1.5 bg-white border border-[#451C25]/10 shadow-md" />
      <div className="absolute inset-0 bg-[#451C25] text-[#F5EFE7] shadow-2xl flex flex-col overflow-hidden">
        <div className="relative h-[42%]">
          <img src={v?.img || "/img/home-hero.jpg"} alt="" aria-hidden="true" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#451C25] via-[#451C25]/20 to-transparent" />
          <div className="absolute top-4 left-4 flex items-center gap-2">
            <BrandMark size={22} variant="ivory" />
            <span className="text-[9px] tracking-[0.28em] uppercase text-white/90" style={K}>Destino Europe</span>
          </div>
        </div>
        <div className="flex-1 px-6 pb-6 -mt-3 flex flex-col">
          <p data-testid="guide-visual-kicker" className="text-[#B3A17D] text-[9px] tracking-[0.26em] uppercase font-semibold" style={K}>{guide ? "Steps to Your New Life" : "Pick the one that fits"}</p>
          <p className="mt-2 text-[20px] md:text-[23px] leading-[1.15]" style={{ ...K, fontWeight: 600 }}>{title}</p>
          <ol data-testid="guide-visual-chapters" className="mt-4 space-y-1.5 border-t border-white/15 pt-3">
            {items.map((ch, i) => (
              <li key={i} className="flex items-baseline gap-2 text-[12px] md:text-[13px] text-white/80" style={S}>
                <span className="text-[#B3A17D] text-[10px]" style={K}>0{i + 1}</span>
                <span className="flex-1 border-b border-dotted border-white/20 pb-0.5">{ch}</span>
              </li>
            ))}
          </ol>
          <p className="mt-auto pt-3 text-[9px] tracking-[0.04em] text-white/55" style={K}><span className="uppercase tracking-[0.22em]">Free guide</span> · by Espíritu Travel</p>
        </div>
      </div>
    </div>
  );
}
